import 'air-datepicker';
import './numberinput'

(function($) {
    $.fn.datepicker.language['en'] = {
        days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        daysMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        today: 'Today',
        clear: 'Clear',
        dateFormat: 'dd/mm/yyyy',
        timeFormat: 'hh:ii aa',
        firstDay: 0
    };
})(jQuery);


export default class BookingWidget {
    bookingForm;
    datepicker;
    datepickerTrigger;
    isDatepickerOpen;

    constructor() {
        this.bookingForm = document.getElementById('bookingForm');
        if (this.bookingForm) {
            this.bookingForm.addEventListener('submit', (e) => {
                e.preventDefault();
                let formData = [];
                for (let i = 0; i < this.bookingForm.length; i++) {
                    if (this.bookingForm.elements[i].name) {
                        formData.push([this.bookingForm.elements[i].name, this.bookingForm.elements[i].value]);
                    }
                }
                let redirect = e.target.getAttribute('action');
                let parameters = 0;
                for (var data of formData) {
                    if (parameters == 0) {
                        redirect += "#"
                    } else {
                        redirect += "&"
                    }
                    redirect += data[0] + '=' + data[1];
                    parameters++;
                }

				// window.location = redirect;
				window.open(redirect, '_blank');
            })
            this.initDatepicker();
        }
    }

    initDatepicker() {
        this.datepickerTrigger = this.bookingForm.querySelector('.checkin');
        if (this.datepickerTrigger) {
            this.isDatepickerOpen = false;
            const datepickerPresentation = this.datepickerTrigger.querySelector('.value');
            const datepickerPlaceholder = this.datepickerTrigger.querySelector('.placeholder');
            this.datepickerTrigger.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.toggleDatePicker();
            })
            document.querySelector('.booking-datepicker-close').addEventListener('click', () => {
                this.closeDatePicker();
            });

            document.body.addEventListener('click', (event) => {
                if (!event.target.closest('.booking-datepicker-wrapper') && !event.target.classList.contains('booking-datepicker-wrapper') && !event.target.classList.contains('datepicker--cell') && !event.target.classList.contains('datepicker--nav-action') && !event.target.closest('.datepicker--nav-action') && !event.target.classList.contains('datepicker--nav-title') && this.isDatepickerOpen) {
                    this.closeDatePicker();
                }
            });

            this.datepicker = document.querySelector('.booking-datepicker-wrapper');
            let maxDate = new Date();
            maxDate.setFullYear(maxDate.getFullYear() + 1);

            $('.booking-datepicker').datepicker({
                firstDay: 1,
                range: true,
                minDate: new Date(),
                maxDate: maxDate,
                dateFormat: 'yyyy-mm-dd',
                prevHtml: '<svg xmlns="http://www.w3.org/2000/svg" width="5.061" height="8.707" viewBox="0 0 5.061 8.707"><path id="Path_865" data-name="Path 865" d="M745,921.674l4,4,4-4" transform="translate(926.381 -744.646) rotate(90)" fill="none" stroke="#422f2f" stroke-width="1"/> </svg>',
                nextHtml: '<svg xmlns="http://www.w3.org/2000/svg" width="5.061" height="8.707" viewBox="0 0 5.061 8.707"><path id="Path_864" data-name="Path 864" d="M745,921.674l4,4,4-4" transform="translate(-921.321 753.353) rotate(-90)" fill="none" stroke="#422f2f" stroke-width="1"/></svg>',
                selectOtherYears: false,
                navTitles: {
                    days: 'MM, yyyy',
                    months: 'yyyy',
                    years: 'yyyy1 - yyyy2'
                },
                onSelect: (formattedDate, date, inst) => {
                    let checkDates;
                    datepickerPlaceholder.style.display = 'none'
                    if (date.length === 2) {
                        checkDates = formattedDate.split(',')
                        document.getElementById('checkin').value = checkDates[0];
                        document.getElementById('checkout').value = checkDates[1];
                        datepickerPresentation.innerHTML = this.formatDate(date[0]) + ' - ' + this.formatDate(date[1]);
                        this.datepicker.classList.add('date-selected');
                        this.toggleDatePicker();
                    } else {
                        checkDates = formattedDate.split(',');
                        document.getElementById('checkin').value = checkDates[0];
                        this.datepicker.classList.remove('date-selected');
                        datepickerPresentation.innerHTML = this.formatDate(date[0]) + ' - ';
                    }
                }
            })
        }
    }

    formatDate(date) {
        var formatter = new Intl.DateTimeFormat('en-gb', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
        });
        return formatter.format(date);
    }

    toggleDatePicker() {
        if (!this.isDatepickerOpen) {
            document.body.scrollIntoView({
                behavior: 'smooth'
            })
        }
        this.isDatepickerOpen = !this.isDatepickerOpen;
        this.datepickerTrigger.classList.toggle('active');
        this.datepicker.classList.toggle('open');
    }

    closeDatePicker() {
        this.isDatepickerOpen = false;
        this.datepickerTrigger.classList.remove('active');
        this.datepicker.classList.remove('open');
    }

}